import { Component, ElementRef, Input, ViewChild, inject } from '@angular/core';
import { ElementComponent } from '../element-wyswyg/element-wyswyg.component';
import { ScrollService } from 'src/app/shared/services/scroll.service';


@Component({
  selector: 'list-wyswyg',
  templateUrl: './list-wyswyg.component.html',
  styleUrls: ['./list-wyswyg.component.css']
})
export class ListWyswygComponent extends ElementComponent {
  @Input() override data: any = {
    list: [
      'Elemento 0',
    ],
    ordered: false,
    startList: 1,
    mark: "circle",
    indent: 0
  };

  lastOlMarker="1";
  lastUlMarker="circle";

  olMarkers: string[] = ["1","a","A","i","I"];
  ulMarkers: string[] = ["circle","disc","square"];

  @ViewChild('wrapper') wrapper!: ElementRef;

  private scrollService: ScrollService;

  constructor(){
    super();
    this.scrollService = inject(ScrollService);
  }

  addElement(event, index?: number): void {
    event.preventDefault();
    const newListItemTextId = 'li-text-'+this.data.prefix+'-'+ (index ?? this.data.list.length)

    if (index==null) {
      this.data.list.push("");
    } else {
      this.data.list = [
        ...this.data.list.slice(0,index!),
        "",
        ...this.data.list.slice(index!)
      ];
    }

    this.focusLine(newListItemTextId);

  }

  checkRemoveLine(event, index: number): void {
    if (this.data.list.length > 1 && event.target.value === "") this.removeLine(index);
  }

  removeLine(index: number): void {
    this.data.list = [
      ...this.data.list.slice(0,index!),
      ...this.data.list.slice(index!+1)
    ];

    const indexToFocus = index-1 < 1 ? 0 : index-1;

    this.focusLine('li-text-'+this.data.prefix+'-'+ indexToFocus)
  }

  focusLine(id) {
    setTimeout(() => {
      this.scrollService.focusElementById(id);
    },0);
  }

  toggleType(){
    this.data.ordered=!this.data.ordered
    if (this.data.ordered) {
      this.lastUlMarker = this.data.mark;
      this.data.mark = this.lastOlMarker;
    } else {
      this.lastOlMarker = this.data.mark;
      this.data.mark = this.lastUlMarker;
    }
  }

  // avoids losing focus when editing any input
  trackByFn(index, item) {
    return index;
  }



}
